"use client";
import o from "styled-components";
import e from "react";
import "./index.es9.js";
import "./index.es10.js";
import "./index.es11.js";
import "./index.es12.js";
import "./index.es13.js";
import "./index.es14.js";
import "./index.es15.js";
import "./index.es16.js";
import "./index.es17.js";
import t from "./index.es62.js";
import "./index.es27.js";
import "./index.es28.js";
import "./index.es19.js";
import "./index.es20.js";
import "./index.es21.js";
import "./index.es22.js";
import "./index.es23.js";
import "./index.es24.js";
import "./index.es25.js";
import "./index.es26.js";
import "./index.es29.js";
import "./index.es30.js";
import "./index.es31.js";
import "./index.es32.js";
import m from "./index.es156.js";
import a from "./index.es157.js";
const n = o.div`
  display: flex;
  flex-direction: column;

  margin: 1rem;

  & > div {
    display: flex;
  }
  ${t.mediaQueries["bl-handset-down"]} {
    & > div {
      align-items: center;
      flex-direction: row-reverse;
      justify-content: space-between;
    }

    .stat-monitor-key-description {
      white-space: nowrap;
      padding: 0.5rem;
    }
    .key-symbol {
      margin: 0.5rem;
    }
  }

  .stat-monitor-spread-key {
    width: 40px;
    height: 15px;
  }
  .stat-monitor-scope-visualization {
    height: 15px;
    width: 0;
    border-right: 4px solid #000;
  }

  ${t.mediaQueries["bl-handset-large-up"]} {
    flex-direction: column;
    & > div {
      display: flex;
      flex-direction: column;
      margin: 0.5rem;
      justify-content: space-between;
      align-items: center;
    }
    .stat-monitor-key-description {
      white-space: nowrap;
      padding-top: 1rem;
    }
  }

  ${t.mediaQueries["bl-tablet-large-up"]} {
    flex-direction: row;
  }
`, V = ({ id: i, scopeName: r }) => /* @__PURE__ */ e.createElement(n, { className: "bl-size-6" }, /* @__PURE__ */ e.createElement("div", null, /* @__PURE__ */ e.createElement("div", { className: "stat-monitor-spread-key key-symbol" }, /* @__PURE__ */ e.createElement(
  a,
  {
    id: `spread-${i}`,
    style: { border: "solid 2px #9d77f0" }
  }
)), /* @__PURE__ */ e.createElement("div", { className: "stat-monitor-key-description" }, "Spredning")), /* @__PURE__ */ e.createElement("div", null, /* @__PURE__ */ e.createElement(m, { className: "key-symbol" }), /* @__PURE__ */ e.createElement("div", { className: "stat-monitor-key-description" }, "Stedets plassering")), /* @__PURE__ */ e.createElement("div", null, /* @__PURE__ */ e.createElement("div", null, /* @__PURE__ */ e.createElement("div", { className: "stat-monitor-scope-visualization key-symbol" })), /* @__PURE__ */ e.createElement("div", { className: "stat-monitor-key-description" }, "Verdi for ", r)), /* @__PURE__ */ e.createElement("div", null));
export {
  V as default
};
//# sourceMappingURL=index.es78.js.map
